import { ValidationMode } from '@wix/ambassador-forms-v1-validation-result/types';
import {
  type ArrayItems,
  type ArrayType,
  type ValidationArrayTypeArrayItems,
  type ValidationArrayType,
} from '@wix/ambassador-forms-v4-form/types';
import {
  type PartialSchema,
  type SomeJSONSchema,
} from 'ajv/dist/types/json-schema';

import { setValidationProperties } from '../../utils/validation';

import { propertySchemaMapper } from './property-schema-mapper';
import { PropertyTypes } from './property-types';

const ARRAY_VALIDATION_PROPERTIES = ['minItems', 'maxItems'];
const ALLOWED_MAX_ITEMS = 100;

export function mapToArraySchemaProperty(
  arrayField: ArrayType | ValidationArrayType,
  validationMode: ValidationMode,
  libraryBasedPhoneFieldValidationEnabled: boolean = false,
): PartialSchema<[]> {
  const validation = arrayField || {};
  const itemsValidation = resolveArrayItemsValidation(
    validationMode,
    validation.items,
    libraryBasedPhoneFieldValidationEnabled,
  );
  return {
    type: PropertyTypes.ARRAY,
    maxItems: ALLOWED_MAX_ITEMS,
    ...resolveRestrictedValidationProperties(arrayField, validationMode),
    ...(itemsValidation && { items: itemsValidation }),
  };
}

function resolveRestrictedValidationProperties(
  arrayField: ArrayType | ValidationArrayType,
  validationMode: ValidationMode,
) {
  if (validationMode !== ValidationMode.UNRESTRICTED_UPDATE) {
    return {
      ...getArrayValidationProperties(arrayField),
    };
  }
  return {};
}

export function getArrayValidationProperties(
  arrayField: ArrayType | ValidationArrayType,
) {
  return setValidationProperties<number>(
    ARRAY_VALIDATION_PROPERTIES,
    arrayField,
    {
      maxItems: (value) =>
        Math.min(value ?? ALLOWED_MAX_ITEMS, ALLOWED_MAX_ITEMS),
    },
  );
}

function resolveArrayItemsValidation(
  validationMode: ValidationMode,
  arrayItems?: ArrayItems | ValidationArrayTypeArrayItems,
  libraryBasedPhoneFieldValidationEnabled: boolean = false,
): Omit<SomeJSONSchema, '$id'> | undefined {
  if (arrayItems) {
    return propertySchemaMapper(
      arrayItems,
      undefined,
      validationMode,
      libraryBasedPhoneFieldValidationEnabled,
    );
  }
  throw Error('Required to specify items type for array');
}
